<template>
  <div @close="eventEmitter('emitChangeBoolean', 'accessibility')">
    <div class="container accessibility-menu">
      <div>
        <button
          v-for="(item, index) in data"
          :key="index"
          type="button"
          :id="index + '_btn'"
          class="col"
          @click="eventEmitter('emitAccesibility', index)"
        >
          <font-awesome-icon :icon="['fas', item.icon]" size="2x" />
          <div>{{ item.title }}</div>
        </button>
      </div>
      <button type="button" id="close_btn" @click="eventEmitter('emitChangeBoolean', 'accessibility')">
        <font-awesome-icon :icon="['far', 'times-circle']" />
      </button>
    </div>
  </div>
</template>


<script>
export default {
  name: "fcwpAccessibility",
  props: ["data"],
  methods: {
    eventEmitter(method, value) {
      var track_data = {
          'action': 'switch accessibility',
          'category': 'site_usage',
          'label': value,
      }
      window.tracker.track(track_data, 'event');
      this.$root.$emit(method, value);
    }
  }
};
</script>


<style scoped lang="scss">
.accessibility-menu {
  background-color: #141213;
  position: fixed;
  top: 50vh;
  left: 50vw;
  display: flex;
  text-align: center;
  width: 25vw;
  transform: translate(-50%, -50%);
  border: #c7c7c5 solid 5px;
  box-shadow: #141213 0px 0px 3px;
  border-radius: 7px;
  z-index: 20000;

  #grayscale_btn {
    color: #c7c7c5;
  }
  #grayscale_btn:hover {
    color: #ffd301;
  }

  button {
    color: #cc6a2a;
    margin: 13px 0;
    height: 120px;
    font-size: 30pt;
    div {
      font-size: 16pt;
    }
  }

  @media (max-width: 1000px) {

      width: 50vw;

  }

  @media (max-width: 500px) {
    button {
      font-size: 20pt;
      height: 105px;
      div {
        font-size: 14pt;
      }
    }
  }

  button:hover {
    color: #ffd301;
  }

  #close_btn {
    height: unset;
    font-size: 22pt;
    position: absolute;
    right: 5px;
    top: 5px;
    margin: auto;
    padding: 0;
    a {
      position: relative;
      top: -10px;
    }
  }
}
.letters #letters_btn,
.grayscale #grayscale_btn,
.contrast #contrast_btn {
  color: #719a0a;
}
</style>